/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class d{constructor(){this.name="",this._nodes=[]}addNode(d){if(this._nodes.includes(d))throw new Error("Node already added");this._nodes.push(d)}forEachNode(d){this._nodes.forEach(d)}}export{d as Scene};
